export default {
    apiKey: "AIzaSyC6yX5StZLHmc3ITTu5HUSwFix8Qe40tU0",
    authDomain: "mmh-dashboard.firebaseapp.com",
    databaseURL: "https://mmh-dashboard.firebaseio.com",
    projectId: "mmh-dashboard",
    storageBucket: "mmh-dashboard.appspot.com",
    messagingSenderId: "961729071732",
};
